var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "OrderDetails",
      staticStyle: {
        padding: "20px 5px",
        background: "#ffffff",
        "box-shadow": "rgb(107 105 105 / 21%) 0px 0px 20px 0px",
        "border-radius": "10px"
      }
    },
    [
      _c(
        "p",
        {
          staticClass: "comeback",
          on: {
            click: function($event) {
              return _vm.comeback()
            }
          }
        },
        [
          _c("span", { staticClass: "el-icon-arrow-left" }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("i18n_Return")))])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "RequestInfo divbox",
          staticStyle: { margin: "3px 29px" }
        },
        [
          _c("h4", [_vm._v(_vm._s(_vm.$t("i18n_Order_info")))]),
          _vm._v(" "),
          _c("ul", { staticClass: "RI_ul" }, [
            _c("li", [
              _c("p", [
                _c("span", {}, [
                  _vm._v(_vm._s(_vm.$t("i18n_tracking_number")) + " ")
                ]),
                _c("span", [_vm._v(_vm._s(_vm.routes.nos || "-"))])
              ]),
              _vm._v(" "),
              _c("p", [
                _c("span", [_vm._v(_vm._s(_vm.$t("i18n_destination")))]),
                _c("span", [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.Alldata.waybilldetails.pod_country || "-") +
                      "\n            "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("p", [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("i18n_arrived_warehouse_date")))
                ]),
                _c("span", [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.Alldata.waybilldetails.inwarehousetime || "-"
                      ) +
                      "\n            "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("p", [
                _c("span", [_vm._v(_vm._s(_vm.$t("i18n_Order_date")))]),
                _c("span", [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.Alldata.waybilldetails.inputtime || "-") +
                      "\n            "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("p", [
                _c("span", {}, [
                  _vm._v(_vm._s(_vm.$t("i18n_origin_port")) + " ")
                ]),
                _c("span", [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.Alldata.waybilldetails.warehouse || "-") +
                      "\n              "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("p", [
                _c("span", [_vm._v(_vm._s(_vm.$t("i18n_Payment_Method")))]),
                _c("span", [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.Alldata.waybilldetails.payType
                          ? _vm.Alldata.waybilldetails.payType === "PP"
                            ? _vm.$t("i18n_domestic_payment")
                            : _vm.$t("i18n_foreign_payment")
                          : "-"
                      ) +
                      "\n            "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("p", [
                _c("span", {}, [
                  _vm._v(_vm._s(_vm.$t("i18n_clearance_metods")) + " ")
                ]),
                _c("span", [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.Alldata.waybilldetails.customsClearanceType
                          ? _vm.Alldata.waybilldetails.customsClearanceType ===
                            "Z"
                            ? _vm.$t("i18n_self_clearing")
                            : _vm.$t(
                                "i18n_Cititran_incharges_of_double_clearing"
                              )
                          : "-"
                      ) +
                      "\n              "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("p", [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("i18n_custom_clearance_method")))
                ]),
                _c("span", [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.Alldata.waybilldetails.declareType
                          ? _vm.Alldata.waybilldetails.declareType === "M"
                            ? _vm.$t("i18n_customs_declaration")
                            : _vm.$t("i18n_Tax_refund")
                          : "-"
                      ) +
                      "\n            "
                  )
                ])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "jackCard", staticStyle: { padding: "20px" } }, [
        _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "center" } },
          [
            _c("img", {
              attrs: {
                src: require("./../../../assets/receiveIcon.png"),
                alt: ""
              }
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                staticStyle: {
                  "margin-left": "10px",
                  "font-size": "20px",
                  "font-weight": "550"
                }
              },
              [_vm._v(_vm._s(_vm.$t("i18n_consignee_information")))]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "reCard" }, [
          _c(
            "span",
            {
              staticStyle: {
                "font-size": "18px",
                "line-height": "40px",
                "font-weight": "600"
              }
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(
                    (_vm.Alldata.deswarehouse &&
                      _vm.Alldata.deswarehouse.warehouse) ||
                      _vm.$t("i18n_no_receiving_information")
                  ) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c("span", { staticStyle: { "line-height": "40px" } }, [
            _vm._v(
              "\n           " +
                _vm._s(
                  (_vm.Alldata.deswarehouse && _vm.Alldata.deswarehouse.tel) ||
                    ""
                ) +
                "\n          " +
                _vm._s(
                  (_vm.Alldata.deswarehouse &&
                    _vm.Alldata.deswarehouse.province) ||
                    ""
                ) +
                "\n          " +
                _vm._s(
                  (_vm.Alldata.deswarehouse && _vm.Alldata.deswarehouse.city) ||
                    ""
                ) +
                "\n          " +
                _vm._s(
                  (_vm.Alldata.deswarehouse && _vm.Alldata.deswarehouse.area) ||
                    ""
                ) +
                "\n          " +
                _vm._s(
                  (_vm.Alldata.deswarehouse &&
                    _vm.Alldata.deswarehouse.address) ||
                    ""
                ) +
                "\n        "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      !_vm.Alldata.message.isgetgoodstodoor
        ? _c(
            "div",
            {
              staticClass: "jackCard",
              staticStyle: {
                overflow: "hidden",
                background: "rgb(253 246 217)"
              }
            },
            [
              _c("div", { staticStyle: { padding: "10px 30px" } }, [
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-size": "26rpx",
                      "font-family": "PingFang SC",
                      "font-weight": "500",
                      color: "#c19822",
                      "line-height": "40rpx"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "i18n_Please_ship_your_package_to_below_warehouse"
                        )
                      )
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { background: "#fff", padding: "15px 30px" } },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "16px",
                        "font-family": "PingFang SC",
                        "font-weight": "550"
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.Alldata.depwarehouse.warehouse || "") +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.Alldata.depwarehouse.tel || "") +
                      "\n        " +
                      _vm._s(_vm.Alldata.depwarehouse.province || "") +
                      "\n        " +
                      _vm._s(_vm.Alldata.depwarehouse.city || "") +
                      "\n        " +
                      _vm._s(_vm.Alldata.depwarehouse.area || "") +
                      "\n        " +
                      _vm._s(_vm.Alldata.depwarehouse.address || "") +
                      "\n      "
                  )
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.Alldata.message.isgetgoodstodoor
        ? _c(
            "div",
            {
              staticClass: "jackCard",
              staticStyle: {
                overflow: "hidden",
                background: "rgb(253 246 217)"
              }
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { background: "#fff", padding: "15px 30px" } },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "16px",
                        "font-family": "PingFang SC",
                        "font-weight": "550"
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.Alldata.message.getgoodsname || "") +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticStyle: { margin: "0 10px" } }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.Alldata.message.getgoodstel || "") +
                        "\n        "
                    )
                  ]),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.Alldata.message.getgoodsprovince || "") +
                      "\n        " +
                      _vm._s(_vm.Alldata.message.getgoodscity || "") +
                      "\n        " +
                      _vm._s(_vm.Alldata.message.getgoodsarea || "") +
                      "\n        " +
                      _vm._s(_vm.Alldata.message.getgoodsaddress || "") +
                      "\n      "
                  )
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "jackCard", staticStyle: { padding: "30px" } }, [
        _c("div", [
          _c(
            "span",
            {
              class: {
                jackTextAc: _vm.acIndex == 1,
                jackText: _vm.acIndex == 2
              },
              staticStyle: { cursor: "pointer", "margin-right": "5px" },
              on: {
                click: function($event) {
                  return _vm.changeAc(1)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("i18n_Forecast_pakcage_info")))]
          ),
          _vm._v(" "),
          _vm.state == 2
            ? _c(
                "span",
                {
                  class: {
                    jackTextAc: _vm.acIndex == 2,
                    jackText: _vm.acIndex == 1
                  },
                  staticStyle: { cursor: "pointer" },
                  on: {
                    click: function($event) {
                      return _vm.changeAc(2)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("i18n_Accurated_package_info")))]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.acIndex == 1
          ? _c(
              "div",
              { staticStyle: { margin: "20px 0" } },
              [
                _c(
                  "el-table",
                  {
                    attrs: {
                      border: "",
                      data: _vm.Alldata.cargobefore,
                      "tooltip-effect": "dark",
                      "header-cell-style": { background: "#F3F3F3" }
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "index",
                        label: _vm.$t("i18n_Serial_number"),
                        width: "75px",
                        "min-width": "8%"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "boxNo",
                        label: _vm.$t("i18n_Cititrans_Tracking_number")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.citiBoxNo || "-") +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1829474195
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "goodstype",
                        label: _vm.$t("i18n_cargo_classification")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.goodstype || "-") +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1052843960
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "goodname",
                        label: _vm.$t("i18n_product_name")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.goodname || "-") +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        4022533460
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "weight",
                        label: _vm.$t("i18n_weight_kgs")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.weight || "-") +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2760248880
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "cbm", label: _vm.$t("i18n_volume_cbm") },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.cbm || "-") +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        165649564
                      )
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "cbmSize",
                        label: _vm.$t("i18n_size_cm"),
                        "min-width": "100px"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.boxL || "-") +
                                    "*" +
                                    _vm._s(scope.row.boxW || "-") +
                                    "*" +
                                    _vm._s(scope.row.boxH || "-") +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        727832342
                      )
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _c("div", { staticStyle: { margin: "20px 0" } }, [
              _c(
                "div",
                { staticClass: "tablebox" },
                [
                  _c(
                    "el-table",
                    {
                      attrs: {
                        border: "",
                        data: _vm.Alldata.cargo,
                        "tooltip-effect": "dark",
                        "header-cell-style": { background: "#F3F3F3" }
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: _vm.$t("i18n_Serial_number"),
                          width: "75px",
                          "min-width": "8%"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "boxNo",
                          label: _vm.$t("i18n_Cititrans_Tracking_number")
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.citiBoxNo || "-") +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "goodstype",
                          label: _vm.$t("i18n_cargo_classification")
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.goodstype || "-") +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "goodname",
                          label: _vm.$t("i18n_product_name")
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.goodname || "-") +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "weight",
                          label: _vm.$t("i18n_weight_kgs")
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.weight || "-") +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "cbm",
                          label: _vm.$t("i18n_volume_cbm")
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.cbm || "-") +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "cbmSize",
                          label: _vm.$t("i18n_size_cm"),
                          "min-width": "100px"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(scope.row.boxL || "-") +
                                    "*" +
                                    _vm._s(scope.row.boxW || "-") +
                                    "*" +
                                    _vm._s(scope.row.boxH || "-") +
                                    "\n            "
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "Information divbox",
          staticStyle: { margin: "3px 29px" }
        },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("i18n_shipping_fee_info"),
                    name: "second"
                  }
                },
                [
                  _c(
                    "el-table",
                    {
                      ref: "multipleTable",
                      staticStyle: {
                        width: "77%",
                        "margin-left": "25px",
                        "border-bottom": "none"
                      },
                      attrs: {
                        border: "",
                        data: _vm.tableData1,
                        "tooltip-effect": "dark",
                        "header-cell-style": { background: "#F3F3F3" }
                      },
                      on: { "selection-change": _vm.handleSelectionChange }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: _vm.$t("i18n_Serial_number"),
                          width: "75px",
                          "min-width": "8%"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.feeitem !==
                                  _vm.$t("i18n_Total_payment") &&
                                scope.row.feeitem !==
                                  _vm.$t("i18n_Covert_to_CNY")
                                  ? _c("span", [
                                      _vm._v(_vm._s(parseInt(scope.$index + 1)))
                                    ])
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "feeitem",
                          label: _vm.$t("i18n_cost_category"),
                          "min-width": "8%"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "amountBefore",
                          label: _vm.$t("i18n_estimated_cost"),
                          "min-width": "8%"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.tableData1[scope.$index]
                                        .amountBefore || "-"
                                    ) +
                                    "\n                " +
                                    _vm._s(
                                      "(" +
                                        (_vm.tableData1[scope.$index]
                                          .amountBeforeCalDesc || "-") +
                                        ")" || "-"
                                    ) +
                                    "\n              "
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "amount",
                          label: _vm.$t("i18n_actual_cost"),
                          "min-width": "8%"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.tableData1[scope.$index].amount
                                    ) +
                                    "\n                " +
                                    _vm._s(
                                      "(" +
                                        (_vm.tableData1[scope.$index]
                                          .amountCalDesc || "-") +
                                        ")" || "-"
                                    ) +
                                    "\n              "
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      staticStyle: {
                        width: "77%",
                        "margin-left": "25px",
                        "border-top": "none",
                        "margin-top": "0px"
                      },
                      attrs: {
                        border: "",
                        data: _vm.twotableData,
                        "cell-style": { padding: "5px 0px" },
                        "show-header": false
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: "",
                          width: "75px",
                          "min-width": "8%"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.feeitem !==
                                  _vm.$t("i18n_Total_payment") &&
                                scope.row.feeitem !==
                                  _vm.$t("i18n_Covert_to_CNY")
                                  ? _c("span", [
                                      _vm._v(_vm._s(parseInt(scope.$index + 1)))
                                    ])
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "feeitem", label: "", "min-width": "8%" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "amountBefore",
                          label: "",
                          "min-width": "8%"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "amount", label: "", "min-width": "8%" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("i18n_tracking_info"),
                    name: "third",
                    lazy: ""
                  }
                },
                [
                  _c(
                    "el-table",
                    {
                      staticClass: "trackTable",
                      attrs: {
                        border: "",
                        data: _vm.tableData,
                        "tooltip-effect": "dark",
                        "header-cell-style": { background: "#F3F3F3" }
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("i18n_Order_Status"),
                          prop: "orderStatus",
                          width: "120px",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("i18n_Pickup_Status"),
                          prop: "THStatus",
                          width: "120px",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("i18n_warehouse_status"),
                          prop: "JCStatus",
                          width: "120px",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("i18n_Booking_Status"),
                          prop: "PGStatus",
                          width: "120px",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("i18n_China_Hong_Kong_Status"),
                          prop: "DGStatus",
                          width: "120px",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("i18n_Trunk_status"),
                          prop: "GXStatus",
                          width: "120px",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("i18n_Customs_clearance_status"),
                          prop: "QGStatus",
                          width: "120px",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("i18n_Distribution_Center_Status"),
                          prop: "FBZXStatus",
                          width: "120px",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("i18n_delivery_status"),
                          prop: "PSStatus",
                          width: "120px",
                          align: "center"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("i18n_download_labels"),
                    name: "download"
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { margin: "10px" },
                      attrs: { type: "success", size: "mini" },
                      on: {
                        click: function($event) {
                          return _vm.downLoadLabel()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("i18n_click_and_download_labels")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "jackRadius",
          attrs: {
            center: "",
            "before-close": _vm.beforeClose,
            visible: _vm.showDialog,
            title: _vm.showPic ? "相关回执" : "箱子轨迹",
            width: "60%"
          },
          on: {
            "update:visible": function($event) {
              _vm.showDialog = $event
            }
          }
        },
        [
          this.showDialog && this.showPic
            ? _c(
                "div",
                _vm._l(_vm.urls, function(item, index) {
                  return _c("el-image", {
                    key: index,
                    staticStyle: {
                      width: "45%",
                      height: "45%",
                      "border-radius": "20px",
                      margin: "10px",
                      "box-shadow": "0px 0px 55px 2px rgba(6, 2, 3, 0.1)"
                    },
                    attrs: { src: item, "preview-src-list": _vm.urls }
                  })
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          this.showDialog && this.showBox
            ? _c(
                "div",
                [
                  _c(
                    "el-timeline",
                    { staticClass: "jackContent" },
                    _vm._l(_vm.boxDatailList, function(activity, index) {
                      return _c(
                        "el-timeline-item",
                        {
                          key: index,
                          attrs: {
                            type: "primary",
                            icon: activity.icon,
                            color: index == 0 ? "" : "#999999",
                            timestamp:
                              activity.occurrenceDate +
                              " " +
                              activity.occurrenceTime
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(activity.name) +
                              "\n            "
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#999999",
                                "margin-top": "6px"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(activity.desc ? activity.desc : "暂无")
                              )
                            ]
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "jackRadius",
          attrs: {
            center: "",
            visible: _vm.showGoodsList,
            title: _vm.$t("i18n_Box_Details"),
            width: "80%"
          },
          on: {
            "update:visible": function($event) {
              _vm.showGoodsList = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-table",
                {
                  ref: "",
                  attrs: {
                    border: "",
                    size: "mini",
                    data: _vm.goodsList,
                    "tooltip-effect": "dark",
                    "header-cell-style": { background: "#5ab53c21" }
                  },
                  on: { "selection-change": _vm.handleSelectionChange }
                },
                [
                  _vm._v("\n          >"),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "boxNo",
                      label: _vm.$t("i18n_Product_name_in_Chinese")
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(scope.row.namec || "-") +
                                "\n            "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "poTrackingNo",
                      label: _vm.$t("i18n_product_name_in_English")
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(scope.row.namee || "-") +
                                "\n            "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "goodstype", label: _vm.$t("i18n_brands") },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(scope.row.brand || "-") +
                                "\n            "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "weight", label: "SKU" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(scope.row.sku || "-") +
                                "\n            "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "cbm", label: _vm.$t("i18n_HTS_code") },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(scope.row.hsCode || "-") +
                                "\n            "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "pcs", label: _vm.$t("i18n_product_value") },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  scope.row.price > 0 ? scope.row.price : "-"
                                ) +
                                "\n            "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "pcs",
                      label: _vm.$t("i18n_Material_in_Chinese")
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(scope.row.materialc || "-") +
                                "\n            "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "pcs",
                      label: _vm.$t("i18n_product_name_in_English")
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(scope.row.materiale || "-") +
                                "\n            "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "pcs",
                      label: _vm.$t("i18n_Product_uses_in_Chinese")
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(scope.row.purposec || "-") +
                                "\n            "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "pcs",
                      label: _vm.$t("i18n_Product_uses_in_English")
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(scope.row.purposee || "-") +
                                "\n            "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "pcs",
                      label: _vm.$t("i18n_Product_Images")
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(scope.row.pcs || "-") +
                                "\n            "
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { padding: "10px 30px" } }, [
      _c(
        "span",
        {
          staticStyle: {
            "font-size": "26rpx",
            "font-family": "PingFang SC",
            "font-weight": "500",
            color: "#c19822",
            "line-height": "40rpx"
          }
        },
        [_vm._v("提货信息")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8a47be94", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a47be94","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PersonalCenter/AirOrder/AirOrderDetail.vue
// module id = null
// module chunks = 